import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function OpportunitiesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.693.244a5.991 5.991 0 0 0-5.988 5.988 5.99 5.99 0 0 0 5.988 5.989 5.991 5.991 0 0 0 5.989-5.989A5.992 5.992 0 0 0 12.692.244zm0 1.711a4.28 4.28 0 0 1 4.278 4.277 4.28 4.28 0 0 1-4.278 4.278 4.279 4.279 0 0 1-4.277-4.278 4.28 4.28 0 0 1 4.277-4.277zM2.428 22.486h10.631a.856.856 0 0 1 0 1.711H1.572a.855.855 0 0 1-.855-.855V21.63a7.7 7.7 0 0 1 7.699-7.7h4.643a.856.856 0 0 1 0 1.712H8.416a5.988 5.988 0 0 0-5.988 5.988v.855zm22.024-6.782h-7.115a.856.856 0 0 1 0-1.71h7.115a.856.856 0 0 1 0 1.71zm-7.115 4.27h7.115a.856.856 0 0 0 0-1.71h-7.115a.856.856 0 0 0 0 1.71zm7.115 4.27h-7.115a.856.856 0 0 1 0-1.71h7.115a.856.856 0 0 1 0 1.71z"
          fill="url(#h85oo7zmwa)"
        />
        <defs>
          <linearGradient id="h85oo7zmwa" x1=".717" y1=".244" x2=".717" y2="24.244" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3E8BFF" />
            <stop offset="1" stop-color="#3E8BFF" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export default OpportunitiesIcon;
